import { Component, Input, Output, EventEmitter } from "@angular/core";

@Component({
  selector: "app-activity-tab-item",
  templateUrl: "./activity-tab-item.component.html",
  styleUrls: ["./activity-tab-item.component.scss"]
})
export class ActivityTabItemComponent {
  @Input() title!: string;
  @Input() subtitle!: string;
  @Input() tabId!: string;
  @Input() selectedTabName!: string;
  @Output() tabClicked = new EventEmitter<{ tabId: string }>();

  get isSelected(): boolean {
    return this.selectedTabName === this.tabId;
  }

  onClick() {
    this.tabClicked.emit({ tabId: this.tabId });
  }
}
